import React, { useEffect, useState } from "react";

import styles from "./FormStep2.module.scss";
import { getItems, getParties } from "../../features/newOrder/newOrderSlice";
import { useAppSelector } from "../../app/hooks";
import { PartyProps } from "../../types/party";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { GiCancel } from "react-icons/gi";
import { OptionsProps } from "../../types/order";
import Select from "react-select";
import { selectStyles } from "../../static/styles";
import ItemForm from "./ItemForm";

const FormStep2 = () => {
  const parties = useAppSelector(getParties);
  const items = useAppSelector(getItems);

  const {
    getValues,
    control,
    register,
    setValue,
    clearErrors,
    formState: { errors },
    // watch,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  // const formItems = watch("items");

  const [selectedParty, setSelectedParty] = useState<PartyProps | null>(null);
  const [itemOption, setItemOption] = useState<OptionsProps[]>([]);

  const handleAppendNewItem = () => {
    append({
      item_id: 0,
      processes: [
        {
          process_id: 0,
          unit_id: 0,
          rate: null,
          qty: null,
          weight: null,
          design: null,
          size: null,
          cartoon: null,
        },
      ],
    });
  };

  const handleChangeItem = async (item_id: number, index: number) => {
    if (item_id && index >= 0) {
      setValue(`items.${index}.item_id`, item_id);
      clearErrors(`items.${index}.item_id`);

      setValue(`items.${index}.processes`, [
        {
          process_id: 0,
          unit_id: 0,
          rate: null,
          qty: null,
          weight: null,
          design: null,
          size: null,
          cartoon: null,
        },
      ]);
    }
  };

  useEffect(() => {
    const party_id = getValues("party_id");
    setSelectedParty(parties.find((p) => p.id === party_id) || null);
  }, [getValues, parties]);

  useEffect(() => {
    setItemOption(
      items.map((item) => ({
        value: item.item.id,
        label: item.item.name,
      })) || []
    );
  }, [items]);

  useEffect(() => {
    if (fields.length <= 0) handleAppendNewItem();
  }, []);

  return (
    <div className={styles.FormStep2}>
      <h2 className="relative w-full text-2xl underline text-primary-1 font-bold mb-4">
        {selectedParty?.firm_name +
          (selectedParty?.name ? " - " + selectedParty?.name : "") +
          (selectedParty?.phone ? " (" + selectedParty?.phone + ")" : "")}
      </h2>

      {fields.map((item, index) => (
        <div className="mt-6" key={index}>
          <h2 className="relative w-full text-2xl underline text-primary-1 font-bold mb-4">
            આઈટમ - {index + 1}
            {index > 0 && (
              <GiCancel
                onClick={() => remove(index)}
                className="absolute z-10 shadow bg-white top-1 right-1 text-3xl text-primary-1 border-2 border-primary-1 p-1 rounded-full"
              />
            )}
          </h2>

          <div className="mt-6">
            <label className="text-primary-1 font-bold">આઈટમ :</label>
            <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 w-full relative rounded">
              <Controller
                {...register(`items.${index}.item_id`, {
                  required: true,
                  min: 1,
                })}
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    value={
                      itemOption.find((val) => val.value === field.value) ||
                      null
                    }
                    className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                    styles={selectStyles}
                    placeholder={"આઈટમ નું નામ સિલેક્ટ કરો"}
                    options={itemOption}
                    onChange={(val: any) => handleChangeItem(val?.value, index)}
                    // isOptionDisabled={(option: any) =>
                    //   formItems.some(
                    //     (item: any) => item.item_id === option.value
                    //   )
                    // }
                  />
                )}
              />
            </div>
            {Array.isArray(errors?.items) && errors.items[index]?.item_id && (
              <span className="text-red-500">આઈટમ નું નામ સિલેક્ટ કરો</span>
            )}
          </div>

          <ItemForm index={index} />
        </div>
      ))}

      <button
        className="mx-auto mt-8 shadow rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
        type="button"
        onClick={handleAppendNewItem}
      >
        આઈટમ ઉમેરો
      </button>
    </div>
  );
};
export default FormStep2;
